import { createFileRoute, redirect } from "@tanstack/react-router";

import {
  coachContentHubQueryOptions,
  contentHubKeys,
} from "src/components/contentHubQueries";
import { ContentHubHubPage } from "src/pages/ContentHubHubPage";

export const Route = createFileRoute(
  "/_auth/_coach/content-hub/$contentHubId/",
)({
  component: RouteComponent,
  ssr: true,
  async loader(props) {
    const contentHub = await props.context.queryClient.query({
      ...coachContentHubQueryOptions(props.params.contentHubId),
      staleTime: "static",
    });

    const firstTab = contentHub.tabs[0];

    if (firstTab) {
      props.context.queryClient.setQueryData(
        [...contentHubKeys.coachHub(props.params.contentHubId), firstTab.id],
        contentHub,
      );

      throw redirect({
        to: "/content-hub/$contentHubId/$",
        params: {
          contentHubId: props.params.contentHubId,
          _splat: firstTab.id,
        },
        replace: true,
      });
    }
  },
});

function RouteComponent() {
  const params = Route.useParams();

  return <ContentHubHubPage contentHubId={params.contentHubId} />;
}
